import React, { Component } from "react";
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";
import * as moment from "moment";
import "moment/locale/pt-br";

// Create styles
const styles = StyleSheet.create({
  page: {
    paddingBottom: 20,
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  container: {
    padding: 20,
    backgroundColor: "#F5F6F8",
    height: "100%",
  },
  title: {
    fontSize: 22,
    color: "#000",
    paddingBottom: 20,
  },
});

export default class PDFDetalhesPedido extends Component {
  renderMetodoPagamento = (pedido) => {
    if (pedido.metodo_pagamento.tipo === "dinheiro") {
      if (pedido.detalhes_pagamento.troco) {
        return "Dinheiro com troco";
      } else {
        return "Dinheiro sem troco";
      }
    } else if (pedido.metodo_pagamento.tipo === "debito") {
      return `Débito - ${pedido.metodo_pagamento.descricao}`;
    } else if (pedido.metodo_pagamento.tipo === "credito") {
      return `Crédito - ${pedido.metodo_pagamento.descricao}`;
    }
  };

  convertToPeso = (peso) => {
    if (peso < 1) {
      return (
        parseFloat(peso * 1000)
          .toFixed(0)
          .toString()
          .replace(".", ",") + "g"
      );
    } else {
      return parseFloat(peso).toFixed(2).toString().replace(".", ",") + "Kg";
    }
  };

  ajustarTempoSeparacao = (tempo) => {
    let minuto = 0;
    let segundos = 0;
    if (tempo >= 60) {
      minuto = parseInt(tempo / 60);
      segundos = tempo % 60;
    }
    return `${minuto} min e ${segundos} seg`;
  };

  renderProdCart = (item, i) => {
    let qnt = item.quantidade;
    let qntFinal = "";
    if (qnt < 10) {
      qntFinal = "0" + qnt.toString();
    } else {
      qntFinal = qnt.toString();
    }
    if (item.item) {
      return (
        <View
          key={i}
          style={{
            flexDirection: "row",
            paddingLeft: 10,
            marginTop: 10,
            justifyContent: "space-between",
          }}
        >
          {item.item.tipo_embalagem === "kg" ? (
            <Text style={{ flex: 0.2, fontSize: 14, color: "black" }}>
              {this.convertToPeso(item.peso)}{" "}
            </Text>
          ) : (
            <Text style={{ flex: 0.2, fontSize: 14, color: "black" }}>
              {parseInt(item.quantidade)} und.{" "}
            </Text>
          )}
          <Text style={{ flex: 0.2, fontSize: 14, color: "black" }}>
            {item.item.codigo_interno}
          </Text>
          <Text style={{ flex: 0.5, fontSize: 14, color: "black" }}>
            {item.item.nome}
          </Text>
          <Text
            style={{
              flex: 0.2,
              fontSize: 14,
              color: "black",
              textAlign: "right",
            }}
          >
            R${" "}
            {parseFloat(item.preco_unitario)
              .toFixed(2)
              .toString()
              .replace(".", ",")}
          </Text>
          <Text
            style={{
              flex: 0.2,
              fontSize: 14,
              color: "black",
              textAlign: "right",
            }}
          >
            R${" "}
            {parseFloat(item.preco_total)
              .toFixed(2)
              .toString()
              .replace(".", ",")}
          </Text>
        </View>
      );
    } else {
      return null;
    }
  };

  render() {
    const quantidadeItens = this.props.pedido.itens.length;
    const endereco_cliente = this.props.pedido.endereco_cliente;
    return (
      <Document>
        <Page size="A4" style={styles.page}>
          <View style={styles.section}>
            <View>
              <Text
                style={{
                  fontWeight: "bold",
                  fontSize: 18,
                  color: "#701B8C",
                  marginBottom: 10,
                }}
              >
                iFeira - Detalhes do Pedido
              </Text>
              <Text
                style={{
                  fontWeight: "bold",
                  fontSize: 16,
                  color: "#3D434D",
                  marginBottom: 10,
                }}
              >
                Código do pedido:
                <Text style={{ fontSize: 16, color: "#701B8C" }}>
                  {"  "}
                  {this.props.pedido.codigo}
                </Text>
              </Text>
              <Text
                style={{ fontWeight: "bold", fontSize: 16, color: "#3D434D" }}
              >
                Status:
                <Text style={{ fontSize: 16, color: "#701B8C" }}>
                  {"  "}
                  {this.props.pedido.status.toUpperCase().replace("_", " ")}
                </Text>
              </Text>

              {this.props.pedido.codigo_seguranca ? (
                <Text
                  style={{
                    fontWeight: "bold",
                    fontSize: 16,
                    color: "#3D434D",
                    paddingTop: 10,
                    marginBottom: 10,
                  }}
                >
                  Código de Segurança:
                  <Text style={{ fontSize: 16, color: "#701B8C" }}>
                    {"  "}
                    {this.props.pedido.codigo_seguranca}
                  </Text>
                </Text>
              ) : null}

              <View style={{ borderTopWidth: 1 }}>
                <Text
                  style={{
                    fontWeight: "bold",
                    fontSize: 14,
                    marginBottom: 10,
                    marginTop: 10,
                  }}
                >
                  Data de Criação:
                  <Text style={{ fontSize: 14, color: "#701B8C" }}>
                    {"  "}
                    {moment(this.props.pedido.createdAt).format("l")}{" "}
                    {moment(this.props.pedido.createdAt).format("LT")}
                  </Text>
                </Text>
              </View>

              {this.props.pedido.agendado ? (
                <Text style={{ fontWeight: "bold", fontSize: 14 }}>
                  Data de Agendamento:
                  <Text style={{ fontSize: 14, color: "#701B8C" }}>
                    {"  "}
                    {moment(this.props.pedido.dataAgendamento).format("l")}{" "}
                    {moment(this.props.pedido.dataAgendamento).format("LT")}
                  </Text>
                </Text>
              ) : null}

              <Text
                style={{ fontWeight: "bold", fontSize: 14, marginVertical: 10 }}
              >
                Data prevista de entrega:
                {this.props.pedido.agendado ? (
                  <Text style={{ fontSize: 14, color: "#701B8C" }}>
                    {"  "}
                    {moment(this.props.pedido.dataAgendamento).format("l")}{" "}
                    {moment(this.props.pedido.dataAgendamento)
                      .add(2, "hours")
                      .format("LT")}
                  </Text>
                ) : (
                  <Text style={{ fontSize: 14, color: "#701B8C" }}>
                    {"  "}
                    {moment(this.props.pedido.dataAgendamento).format("l")}{" "}
                    {moment(this.props.pedido.createdAt)
                      .add(3, "hours")
                      .format("LT")}
                  </Text>
                )}
              </Text>

              <View
                style={{
                  borderTopWidth: 1,
                  flexDirection: "row",
                  paddingTop: 10,
                  justifyContent: "space-between",
                }}
              >
                <Text
                  style={{ fontSize: 14, fontWeight: "bold", color: "black" }}
                >
                  Valor Subtotal
                </Text>
                <Text style={{ fontSize: 14, color: "black" }}>
                  {parseInt(quantidadeItens)} itens
                </Text>
                <Text style={{ fontSize: 14, color: "black" }}>
                  {this.convertToPeso(this.props.pedido.peso_total)}
                </Text>
                <Text
                  style={{ fontSize: 14, fontWeight: "bold", color: "#701B8C" }}
                >
                  R${" "}
                  {parseFloat(this.props.pedido.detalhes_pagamento.subtotal)
                    .toFixed(2)
                    .toString()
                    .replace(".", ",")}
                </Text>
              </View>

              {this.props.pedido.metodo_pagamento ? (
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    paddingTop: 10,
                    alignItems: "center",
                  }}
                >
                  <Text
                    style={{ fontSize: 14, fontWeight: "bold", color: "black" }}
                  >
                    {this.props.pedido.metodo_pagamento.metodo ===
                    "pagamento_na_entrega"
                      ? "Pagamento na entrega"
                      : "Pagamento no App"}{" "}
                  </Text>
                  <Text style={{ fontSize: 14, color: "black" }}>
                    -{" "}
                    {this.props.pedido.metodo_pagamento.tipo === "debito"
                      ? " Débito "
                      : this.props.pedido.metodo_pagamento.tipo === "credito"
                      ? " Crédito "
                      : " Dinheiro "}
                    {this.props.pedido.metodo_pagamento.descricao}
                  </Text>
                </View>
              ) : null}

              {this.props.pedido.cliente ? (
                <View
                  style={{
                    borderTopWidth: 1,
                    marginTop: 15,
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    paddingVertical: 5,
                  }}
                >
                  <Text
                    style={{ fontSize: 14, fontWeight: "bold", color: "black" }}
                  >
                    Cliente:
                  </Text>
                  <Text
                    style={{ fontSize: 14, color: "black", marginLeft: 10 }}
                  >
                    {this.props.pedido.cliente.nome}
                  </Text>
                </View>
              ) : null}
              {this.props.pedido.cliente?.cnpj ? (
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    paddingVertical: 5,
                  }}
                >
                  <Text
                    style={{ fontSize: 14, fontWeight: "bold", color: "black" }}
                  >
                    CNPJ:
                  </Text>
                  <Text
                    style={{ fontSize: 14, color: "black", marginLeft: 10 }}
                  >
                    {this.props.pedido.cliente.cnpj}
                  </Text>
                </View>
              ) : null}
              {this.props.pedido.cliente?.usuario ? (
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    paddingVertical: 5,
                  }}
                >
                  <Text
                    style={{ fontSize: 14, fontWeight: "bold", color: "black" }}
                  >
                    Email:
                  </Text>
                  <Text
                    style={{ fontSize: 14, color: "black", marginLeft: 10 }}
                  >
                    {this.props.pedido.cliente.usuario.email}
                  </Text>
                </View>
              ) : null}
              {endereco_cliente ? (
                <View
                  style={{ justifyContent: "flex-start", paddingVertical: 5 }}
                >
                  <Text
                    style={{
                      fontSize: 14,
                      fontWeight: "bold",
                      color: "black",
                      paddingBottom: 5,
                    }}
                  >
                    Endereço do cliente:
                  </Text>
                  <Text
                    style={{ fontSize: 14, color: "black", marginLeft: 10 }}
                  >
                    {endereco_cliente ? endereco_cliente.rua : null},{" "}
                    {endereco_cliente ? endereco_cliente.numero : null},{" "}
                    {endereco_cliente ? endereco_cliente.bairro : null}
                  </Text>
                  <Text
                    style={{ fontSize: 14, color: "black", marginLeft: 10 }}
                  >
                    {endereco_cliente ? endereco_cliente.complemento : null},{" "}
                    {endereco_cliente ? endereco_cliente.referencia : null}
                  </Text>
                </View>
              ) : null}

              {this.props.pedido.detalhes_pagamento.cpf ? (
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    paddingVertical: 5,
                  }}
                >
                  <Text
                    style={{ fontSize: 14, fontWeight: "bold", color: "black" }}
                  >
                    CPF/CNPJ na nota
                  </Text>
                  <Text
                    style={{ fontSize: 14, color: "black", marginLeft: 10 }}
                  >
                    {this.props.pedido.detalhes_pagamento.cpf}
                  </Text>
                </View>
              ) : null}

              {this.props.pedido.entregador ? (
                <View
                  style={{
                    borderTopWidth: 1,
                    marginTop: 15,
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    paddingVertical: 5,
                  }}
                >
                  <Text
                    style={{ fontSize: 14, fontWeight: "bold", color: "black" }}
                  >
                    Entregador:
                  </Text>
                  <Text
                    style={{ fontSize: 14, color: "black", marginLeft: 10 }}
                  >
                    {this.props.pedido.entregador.nome}
                  </Text>
                </View>
              ) : null}

              {this.props.pedido.tempoSeparacao ? (
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    paddingVertical: 5,
                  }}
                >
                  <Text
                    style={{ fontSize: 14, fontWeight: "bold", color: "black" }}
                  >
                    Tempo de Separação
                  </Text>
                  <Text
                    style={{ fontSize: 14, color: "black", marginLeft: 10 }}
                  >
                    {this.ajustarTempoSeparacao(
                      this.props.pedido.tempoSeparacao
                    )}
                  </Text>
                </View>
              ) : null}

              <View
                style={{
                  borderTopWidth: 1,
                  borderBottomColor: "rgba(227, 228, 230, 1)",
                  paddingTop: 20.5,
                  marginTop: 15,
                }}
              >
                <Text
                  style={{ fontSize: 14, fontWeight: "bold", color: "black" }}
                >
                  Resumo do Pedido
                </Text>
                <Text style={{ marginTop: 20 }}>
                  Total de {parseInt(quantidadeItens)} itens,{" "}
                  {this.convertToPeso(this.props.pedido.peso_total)}
                </Text>

                {this.props.pedido.itens.map((item, i) =>
                  this.renderProdCart(item, i)
                )}

                {this.props.pedido.detalhes_pagamento.troco ? (
                  <>
                    <View
                      style={{
                        justifyContent: "space-between",
                        flexDirection: "row",
                        marginTop: 20,
                        marginBottom: 10,
                      }}
                    >
                      <Text style={{ fontSize: 14, color: "black" }}>
                        Troco
                      </Text>
                      <Text style={{ fontSize: 14, color: "black" }}>
                        R${" "}
                        {parseFloat(this.props.pedido.detalhes_pagamento.troco)
                          .toFixed(2)
                          .toString()
                          .replace(".", ",")}
                      </Text>
                    </View>
                    <View
                      style={{
                        justifyContent: "space-between",
                        marginBottom: 10,
                        flexDirection: "row",
                      }}
                    >
                      <Text style={{ fontSize: 14, color: "black" }}>
                        Valor pago pelo cliente{" "}
                      </Text>
                      <Text style={{ fontSize: 14, color: "black" }}>
                        R${" "}
                        {parseFloat(
                          this.props.pedido.detalhes_pagamento
                            .dinheiro_pago_cliente
                        )
                          .toFixed(2)
                          .toString()
                          .replace(".", ",")}
                      </Text>
                    </View>
                  </>
                ) : null}

                <View
                  style={{
                    justifyContent: "space-between",
                    marginBottom: 20,
                    marginTop: 30,
                    flexDirection: "row",
                  }}
                >
                  <Text style={{ fontSize: 14, color: "black" }}>
                    Valor do frete
                  </Text>
                  <Text style={{ fontSize: 14, color: "black" }}>
                    R${" "}
                    {parseFloat(this.props.pedido.detalhes_pagamento.frete)
                      .toFixed(2)
                      .toString()
                      .replace(".", ",")}
                  </Text>
                </View>

                {this.props.pedido.detalhes_pagamento.valor_taxa_servico ? (
                  <View
                    style={{
                      justifyContent: "space-between",
                      marginBottom: 20,
                      flexDirection: "row",
                    }}
                  >
                    <Text style={{ fontSize: 14, color: "black" }}>
                      Taxa de serviço
                    </Text>
                    <Text style={{ fontSize: 14, color: "black" }}>
                      R${" "}
                      {parseFloat(
                        this.props.pedido.detalhes_pagamento.valor_taxa_servico
                      )
                        .toFixed(2)
                        .toString()
                        .replace(".", ",")}
                    </Text>
                  </View>
                ) : null}
                {this.props.pedido?.detalhes_desconto?.cupom && (
                  <>
                    <View
                      style={{
                        justifyContent: "space-between",
                        marginTop: 20,
                        flexDirection: "row",
                      }}
                    >
                      <Text style={{ fontSize: 14, color: "black" }}>
                        Cupom
                      </Text>
                      <Text style={{ fontSize: 14, color: "black" }}>
                        {this.props.pedido.detalhes_desconto.cupom.codigo}
                      </Text>
                    </View>
                    <View
                      style={{
                        justifyContent: "space-between",
                        marginTop: 20,
                        flexDirection: "row",
                      }}
                    >
                      <Text style={{ fontSize: 14, color: "black" }}>
                        Tipo do Cupom
                      </Text>
                      <Text style={{ fontSize: 14, color: "black" }}>
                        {this.props.pedido.detalhes_desconto.cupom.tipo_desconto.toUpperCase()}
                      </Text>
                    </View>
                    <View
                      style={{
                        justifyContent: "space-between",
                        marginTop: 20,
                        flexDirection: "row",
                      }}
                    >
                      <Text style={{ fontSize: 14, color: "black" }}>
                        Valor do Desconto
                      </Text>
                      <Text style={{ fontSize: 14, color: "black" }}>
                        - R${" "}
                        {this.props.pedido.detalhes_desconto.cupom
                          ?.tipo_desconto === "frete_gratis"
                          ? parseFloat(
                              this.props.pedido.detalhes_pagamento
                                .frete_inicial || 0
                            )
                              .toFixed(2)
                              .toString()
                              .replace(",", ".")
                          : parseFloat(
                              this.props.pedido.detalhes_desconto.cupom
                                ?.valor_desconto
                            )
                              .toFixed(2)
                              .toString()
                              .replace(",", ".")}
                      </Text>
                    </View>
                  </>
                )}
                <View
                  style={{
                    justifyContent: "space-between",
                    marginTop: 20,
                    marginBottom: 20,
                    flexDirection: "row",
                  }}
                >
                  <Text
                    style={{ fontSize: 14, fontWeight: "bold", color: "black" }}
                  >
                    Valor total
                  </Text>
                  <Text
                    style={{
                      fontSize: 18,
                      fontWeight: "bold",
                      color: "#701B8C",
                    }}
                  >
                    R${" "}
                    {parseFloat(this.props.pedido.valor_total)
                      .toFixed(2)
                      .toString()
                      .replace(".", ",")}
                  </Text>
                </View>
              </View>
            </View>
            <Text style={{ fontSize: 12 }}>
              {"*Emitido em - "}
              {moment(Date.now()).format("l")} {moment(Date.now()).format("LT")}
            </Text>
          </View>
        </Page>
      </Document>
    );
  }
}
